import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@saucelabs/sl-component-buttons';
import CopyText from '@saucelabs/sl-component-copy-text';
import { FormControl } from '@saucelabs/sl-component-form';
import { Row, Col } from '@saucelabs/sl-component-grid';
import { Modal } from '@saucelabs/sl-component-overlay';
import modalConnect from '@saucelabs/sl-container-modal';

const VIRTUAL_SESSION_CLIPBOARD_MODAL_KEY = 'virtualSessionClipboard';

class ClipboardModal extends Component {
  constructor(props) {
    super(props);

    const { clipEvents } = props;
    this.state = {
      receivedText: '',
    };
    this.onReceiveCallback = (evt) => this.setReceivedText(evt.text);
    clipEvents.addListener('receive', this.onReceiveCallback);
  }

  componentDidMount() {
    this.setReceivedText();
  }

  componentWillUnmount() {
    const { clipEvents } = this.props;
    clipEvents.removeListener('receive', this.onReceiveCallback);
  }

  get receiveId() {
    const { jobId } = this.props;
    return `novnc-clipboard-receive-${jobId}`;
  }

  get sendId() {
    const { jobId } = this.props;
    return `novnc-clipboard-send-${jobId}`;
  }

  setReceivedText(text = null) {
    // receiveElement is always null if the new version of NoVNC component is used
    const receiveElement = document.querySelector(`#${this.receiveId}`);
    const isTextSetByCaller = typeof text === 'string' || text instanceof String;
    if (!receiveElement && !isTextSetByCaller) {
      return;
    }
    const receivedText = (isTextSetByCaller ? text : receiveElement?.value) || '';
    this.setState({ receivedText });
  }

  handleClipSend = () => {
    const { clipEvents, onHide } = this.props;
    const { receivedText } = this.state;

    const sendElement = document.querySelector(`#${this.sendId}`);
    const sendText = (sendElement?.value) || receivedText;

    this.setState({ receivedText: sendText });
    clipEvents.emit('send', {
      text: sendText,
    });
    onHide();
  }

  render() {
    const { onHide, show } = this.props;
    const { receivedText } = this.state;

    return (
      <Modal
        onHide={onHide}
        show={show}
      >
        <Modal.Header>
          <Modal.Title>Remote Clipboard</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs>
              <h5>SEND TEXT TO REMOTE CLIPBOARD</h5>
              <Row>
                <Col xs={9}>
                  <FormControl
                    id={this.sendId}
                    type="text"
                  />
                </Col>
                <Col xs={3}>
                  <Button
                    block
                    category="action"
                    onClick={this.handleClipSend}
                  >
                    Send
                  </Button>
                </Col>
              </Row>

              <br />

              <h5>REMOTE CLIPBOARD</h5>
              <CopyText
                text={receivedText}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            category="default"
            material
            onClick={onHide}
            size="sm"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

ClipboardModal.propTypes = {
  clipEvents: PropTypes.object.isRequired,
  jobId: PropTypes.string.isRequired,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default modalConnect(VIRTUAL_SESSION_CLIPBOARD_MODAL_KEY, ClipboardModal);
export {
  ClipboardModal,
  VIRTUAL_SESSION_CLIPBOARD_MODAL_KEY,
};
